<template>
  <div v-show="showAlertForSmallScreen" class="alert-small-screen">
    <p>This site is only supported on larger screens. Please use a desktop or maximize your browser window.</p>
  </div>
  <div v-show="!showAlertForSmallScreen">

    <div v-if="status == 'DONE'">
      <div id="whole-intro">
        <div id="variant-id-title">
          <h3 class="description">
            <span data-cancopy="yes" class="truncate-tooltip" :data-copy="truncateWrapper(id, 20).fullText"
              :data-tooltip="truncateWrapper(id, 20).fullText">
              {{ truncateWrapper(id, 20).displayText }}
            </span>&nbsp;
            <sub class="system-coord">GRCh37</sub>
            <!-- <span @click="copy" :class="{ 'copy-btn': true, 'color-blue': isClicked }" id="copy"
              class="material-symbols-outlined">
              file_copy
            </span> -->
          </h3>
        </div>
        <div id="reference">
          <div v-if="metaInfo" class="variant-info-table">
            <table>
              <thead>
              </thead>
              <tbody>
                <tr>
                  <td class="right-col"><b>RSID</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td><span class="rsid-badge"><span class="truncate-tooltip" data-cancopy="yes"
                        style="cursor: pointer;" :data-copy="getStringWrapper(rs_id[0])"
                        :data-tooltip="getStringWrapper(rs_id[0])">{{ getStringWrapper(rs_id[0]) }}</span> &nbsp; <span
                        @click="showExternal" id="showExternal" class="material-symbols-outlined info-btn">
                        info
                      </span></span></td>
                </tr>
                <tr>
                  <td class="right-col"><b>Ancestral &gt; Derived</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td>
                    <span class="pass-badge">
                      <span data-cancopy="yes" class="truncate-tooltip"
                        :data-copy="metaInfo.ANC + ' > ' + truncateWrapper(metaInfo.DER, 18).fullText"
                        :data-tooltip="metaInfo.ANC + ' > ' + truncateWrapper(metaInfo.DER, 18).fullText">
                        {{ metaInfo.ANC }} &gt; {{ truncateWrapper(metaInfo.DER, 18).displayText }}
                      </span>

                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="right-col"><b>Gene</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td><span class="pass-badge"><span data-cancopy="yes" class="truncate-tooltip"
                        :data-copy="truncateWrapper(metaInfo.GENE, 20).fullText"
                        :data-tooltip="truncateWrapper(metaInfo.GENE, 20).fullText">
                        {{ truncateWrapper(metaInfo.GENE, 18).displayText }}
                      </span></span></td>
                </tr>
                <tr>
                  <td class="right-col"><b>Consequence</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td><span class="pass-badge"><span data-cancopy="yes" class="truncate-tooltip"
                        :data-copy="truncateWrapper(metaInfo.Consequence, 18).fullText"
                        :data-tooltip="truncateWrapper(metaInfo.Consequence, 18).fullText">
                        {{ truncateWrapper(metaInfo.Consequence, 18).displayText }}
                      </span></span></td>
                </tr>
                <tr>
                  <td class="right-col"><b>Impact</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td><span class="pass-badge"><span data-cancopy="yes" class="truncate-tooltip"
                        :data-copy="truncateWrapper(metaInfo.IMPACT, 18).fullText"
                        :data-tooltip="truncateWrapper(metaInfo.IMPACT, 18).fullText">
                        {{ truncateWrapper(metaInfo.IMPACT, 18).displayText }}
                      </span></span></td>
                </tr>
                <tr>
                  <td class="right-col"><b>S</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td>
                    <span class="pass-badge">
                      <span data-cancopy="yes" class="truncate-tooltip" :data-copy="truncateWrapper(`${(metaInfo.S_DER * 100).toFixed(2)}% ± ${(metaInfo.SE * 100).toFixed(2)}%
                        s.e.`, 24).fullText" :data-tooltip="'Selection coefficient of the derived allele'">
                        {{ truncateWrapper(`${(metaInfo.S_DER * 100).toFixed(2)}% ± ${(metaInfo.SE * 100).toFixed(2)}%
                        s.e.`, 24).fullText }}
                      </span>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td class="right-col">
                    <b>Posterior (<span
                        style="font-family: 'Times New Roman', serif; font-size: 1.2em;">&pi;</span>)</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </td>
                  <td>
                    <span class="pass-badge">
                      <span data-cancopy="yes" class="truncate-tooltip"
                        :data-copy="truncateWrapper(metaInfo.pi.toFixed(2), 24).fullText"
                        :data-tooltip="'Posterior probability of a true selection signal given the observed X statistic'">
                        {{ truncateWrapper(metaInfo.pi.toFixed(2), 24).fullText }}
                      </span>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td class="right-col"><b>FDR</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td>
                    <span class="pass-badge">
                      <span data-cancopy="yes" class="truncate-tooltip"
                        :data-copy="truncateWrapper(metaInfo.FDR.toFixed(2), 24).fullText"
                        :data-tooltip="'False discovery rate (FDR) is the expected proportion of false positives among the detected signals of selection, given the observed X statistic.'">
                        {{ truncateWrapper(metaInfo.FDR.toFixed(2), 24).fullText }}
                      </span>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td class="right-col"><b>X</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td>
                    <span class="pass-badge">
                      <span data-cancopy="yes" class="truncate-tooltip"
                        :data-copy="truncateWrapper(metaInfo.X_DER.toFixed(2), 24).fullText"
                        :data-tooltip="'Z-score of the selection coefficient of the derived allele (adjusted for inflation; see [1] on the About Page)'">
                        {{ truncateWrapper(metaInfo.X_DER.toFixed(2), 24).fullText }}
                      </span>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td class="right-col"><b>P<sub>X</sub></b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td>
                    <span class="pass-badge">
                      <span data-cancopy="yes" class="truncate-tooltip"
                        :data-copy="truncateWrapper(metaInfo.PX.toExponential(1), 24).fullText"
                        :data-tooltip="'P-value of X, assuming X follows a normal distribution.'">
                        {{ truncateWrapper(metaInfo.PX.toExponential(1), 24).fullText }}
                      </span>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td class="right-col"><b>P (Batch Effect)</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td>
                    <span class="pass-badge">
                      <span data-cancopy="yes" class="truncate-tooltip"
                        :data-copy="truncateWrapper(metaInfo.resid_pearson_pval.toExponential(1), 24).fullText"
                        :data-tooltip="'P-value is based on the discrepancy between estimates with and without modern samples. A small P-value could indicate a batch effect.'">
                        {{ truncateWrapper(metaInfo.resid_pearson_pval.toExponential(1), 24).fullText }}
                      </span>
                    </span>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div id="reg-info">
          <span class="reset-reg">
            <span data-cancopy="no" class="truncate-tooltip" data-tooltip="Reset">
              <span class="material-symbols-outlined" style="font-size: 21px;">autorenew</span>
            </span>
          </span>
          <span class="expand-reg">
            <span data-cancopy="no" class="truncate-tooltip" data-tooltip="Expand Y-Axis">
              <span class="material-symbols-outlined" style="font-size: 21px;">expand_all</span>
            </span>
          </span>
          <span class="download-reg">
            <span data-cancopy="no" class="truncate-tooltip" data-tooltip="Download Figure" @click="downloadReg">
              <span class="material-symbols-outlined" style="font-size: 21px;">photo_camera</span>
            </span>
          </span>
          <span class="download-reg-tsv">
            <span data-cancopy="no" class="truncate-tooltip" data-tooltip="Download TSV" @click="downloadRegTsv">
              <span class="material-symbols-outlined" style="font-size: 21px;">file_save</span>
            </span>
          </span>
          <span class="switch-pos">
            <span data-cancopy="no" class="truncate-tooltip" data-tooltip="Light Mode / Dark Mode">
              <label class="switch">
                <input id="darkModer" type="checkbox" checked>
                <span class="slider round"></span>
              </label>
            </span>
          </span>
          <span class="legend-box">
            <span data-cancopy="no" class="truncate-tooltip legend" data-tooltip="Western Hunter Gatherers">
              <span class="legend-item-whg">..</span> WHG
            </span>
            <span data-cancopy="no" class="truncate-tooltip legend" data-tooltip="Early European Farmers">
              <span class="legend-item-eef">..</span> EEF
            </span>
            <span data-cancopy="no" class="truncate-tooltip legend" data-tooltip="Steppe Pastoralists">
              <span class="legend-item-steppe">..</span> Steppe
            </span>
            <span data-cancopy="no" class="truncate-tooltip legend" data-tooltip="Observed Data">
              <span class="legend-item-observed">..</span> Observed
            </span>
            <span data-cancopy="no" class="truncate-tooltip legend" data-tooltip="GLMM Prediction">
              <span class="legend-item-prediction">..</span> Model Prediction
            </span>
          </span>

          <div id="reg-plot" style="font-family: Ubuntu !important; margin-left: 10px"></div>
        </div>
      </div>
      <div id="mainContainer">
        <div id="tabbtn">
          <button id="gentab" v-bind:class="{ active: this.showPhenoTool == true }" @click="this.showPhenoTool = true">
            PhenoTool
          </button>
        </div>
        <div id="genoToggle">
          <phenoKit />
        </div>
      </div>
    </div>
    <div class="waiting" v-if="status == 'WAIT' || status == 'FAIL'">
      <h1 class="wait-title">
        <b style="color: #A51C30">A</b><b style="color: #A51C30">GE</b><b style="color: #A51C30">S</b>
      </h1>
      <div v-if="status == 'WAIT'" class="loadbar">
        <h4>Loading Data... This should take only a few seconds.</h4>
        <br />
        <br />
        <ring-loader :loading="gridLoading" :color="gridColor" :size="gridSize"></ring-loader>
      </div>
      <div v-if="hasLogined && status == 'FAIL'" class="loadbar">
        <h4 class="red">
          No Exact Matching
          Variant Found!
        </h4>
        <router-link class="resource" to="/">AGES Search Engine</router-link>
      </div>
      <div v-if="hasLogined == false" class="loadbar">
        <h4 class="red">
          You Must Login First
        </h4>
        <a class="resource" href="mailto:alek0991@gmail.com">Contact Your Supervisor</a>
      </div>
    </div>
  </div>
</template>

<script>
import PhenoKit from "@/components/PhenoKit/index.vue";
import RingLoader from "vue-spinner/src/RingLoader.vue";
import axios from "axios";
import { isValidToken } from "@/utils/login.js"
import { smallScreenMixin } from '@/mixins/smallScreenMixin';
import Swal from 'sweetalert2';
import { getString, truncate } from "@/utils/string.js";
import html2canvas from 'html2canvas';

export default {
  name: "Main",
  mixins: [smallScreenMixin],
  components: {
    RingLoader,
    PhenoKit,
  },
  data() {
    return {
      gridLoading: "loading",
      gridColor: "#A51C30",
      gridSize: "100px",
      margin: "10px",
      radius: "2px",
      id: "No ID",
      metaInfo: null,
      clientId: "",
      rs_id: Array(),
      isClicked: false,
      phenoData: null,
      status: "WAIT",
      loadingDownloadReg: false,
      showPhenoTool: true,
      hasLogined: false,
      regContainer: null
    };
  },
  async mounted() {
    const intervalId = setInterval(() => {
      const tooltips = document.querySelectorAll('.truncate-tooltip');
      if (tooltips.length == 22) {
        this.setTooltip();
        clearInterval(intervalId);
      }
    }, 200);
    this.hasLogined = isValidToken(localStorage.getItem('ages_hms_access_token'))
    this.$store.state.id = await this.$route.params.id;
    this.id = await this.$route.params.id;
    await this.setUpPage();
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        this.$router.go();
      },
    );
  },
  methods: {
    setTooltip() {
      document.querySelectorAll('.truncate-tooltip').forEach(item => {
        item.addEventListener('mouseenter', function (e) {
          let tooltip = document.createElement('div');
          tooltip.classList.add('tabulator-popup', 'tabulator-popup-container');

          let tooltipContent = document.createElement('p');
          tooltipContent.innerText = e.target.dataset.tooltip;
          tooltipContent.style.fontFamily = 'Ubuntu';
          tooltipContent.style.padding = '3px';

          tooltip.appendChild(tooltipContent);

          document.body.appendChild(tooltip);

          let rect = e.target.getBoundingClientRect();
          let tooltipRect = tooltip.getBoundingClientRect();

          tooltip.style.position = 'absolute';
          tooltip.style.top = `${rect.top + window.scrollY - tooltipRect.height - 5}px`; // 5px above
          tooltip.style.left = `${rect.left + (rect.width / 2) - (tooltipRect.width / 2)}px`; // Center horizontally

          e.target.tooltipRef = tooltip;
        });

        item.addEventListener('mouseleave', function (e) {
          if (e.target.tooltipRef) {
            document.body.removeChild(e.target.tooltipRef);
          }
        });

        item.addEventListener('click', function (e) {
          let canCopy = e.target.dataset.cancopy;
          let fullText = e.target.dataset.copy;

          if (canCopy != "yes") {
            return;
          }

          navigator.clipboard.writeText(fullText).then(() => {
            const showToast = (message) => {
              let toast = document.createElement('div');
              toast.classList.add('toast');
              toast.innerText = message;
              document.body.appendChild(toast);

              setTimeout(() => {
                toast.style.opacity = '1';
              }, 100);

              setTimeout(() => {
                toast.style.opacity = '0';
                setTimeout(() => {
                  document.body.removeChild(toast);
                }, 200);
              }, 800);
            }
            showToast('Copied to clipboard');
          });
        });
      });
    },
    downloadReg() {
      const element = document.getElementById("reg-info");
      const elementsToHide = document.querySelectorAll(".expand-reg, .download-reg, .download-reg-tsv, .switch-pos, .reset-reg");
      elementsToHide.forEach(el => {
        el.style.visibility = "hidden";
      });
      html2canvas(element, {
        scale: 4
      }).then(canvas => {
        const imageData = canvas.toDataURL();
        const link = document.createElement('a');
        link.href = imageData;
        link.download = `trajectory-plot-${this.id}.png`;
        link.click();
        elementsToHide.forEach(el => {
          el.style.visibility = "visible";
        });
      });
    },
    downloadRegTsv() {
      let ID = this.id;
      this.loadingDownloadReg = true;
      this.axiosHandler()
        .post(
          `/api/download-reg-data`,
          {
            id: ID,
            client_id: this.clientId
          },
          { responseType: "blob" }
        )
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/tab-separated-values",
          });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Trajectory-${ID}.tsv`);
          document.body.appendChild(link);
          link.click();

          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error downloading the file:", error);
        })
        .finally(() => {
          this.loadingDownloadReg = false;
        });
    },
    truncateWrapper(string, maxChar = 30) {
      if (string) {
        if (string.length > maxChar) {
          return {
            displayText: string.slice(0, maxChar) + '...',
            fullText: string
          };
        }
        return {
          displayText: string,
          fullText: string
        };
      } else {
        return {
          displayText: "NA",
          fullText: "NA"
        };
      }
    },
    getStringWrapper(string) {
      return getString(string)
    },
    showExternal() {
      let rs_id = this.rs_id;
      let id = this.id;
      Swal.fire({
        title: '<p style="font-family: Ubuntu; font-size: 20px;">External Resources</p>',
        html: `
    <div style="text-align: left; font-family: Ubuntu;">
          <p style="margin-bottom: 10px; font-size: 14px;"><strong>gnomAD Browser:</strong> 
        <a class="resource" style="font-size: 14px;" href="https://gnomad.broadinstitute.org/variant/${id.replace(/_/g, '-') + '?dataset=gnomad_r2_1'}" target="_blank">gnomAD Browser</a>
      </p>
      <p style="margin-bottom: 10px; font-size: 14px;"><strong>UCSC Genome Browser:</strong> 
        <a class="resource" style="font-size: 14px;" href="https://genome.ucsc.edu/cgi-bin/hgTracks?db=hg19&highlight=hg19.chr${id.split('_')[0]}:${id.split('_')[1]}-${id.split('_')[1]}&position=chr${id.split('_')[0]}:${id.split('_')[1] - 50000}-${parseInt(id.split('_')[1]) + 50000}" target="_blank">UCSC Genome Browser</a>
      </p>
        <p style="margin-bottom: 10px; font-size: 14px;"><strong>GGV: Allele Frequency:</strong> 
        <a class="resource" style="font-size: 14px;" href="https://popgen.uchicago.edu/ggv/?data=%221000genomes%22&chr=${id.split('_')[0]}&pos=${id.split('_')[1]}" target="_blank">GGV: Allele Frequency</a>
      </p>
        <p style="margin-bottom: 10px; font-size: 14px;"><strong>GWAS Catalog:</strong> 
        ${rs_id.map((item, index) => `<a class="resource" style="font-size: 14px;" href="https://www.ebi.ac.uk/gwas/search?query=${item}" target="_blank">${item}${index + 1 < rs_id.length ? ', ' : ''}</a>`).join('')}
      </p>
      <p style="margin-bottom: 10px; font-size: 14px;"><strong>dbSNP:</strong> 
        ${rs_id.map((item, index) => `<a class="resource" style="font-size: 14px;" href="https://www.ncbi.nlm.nih.gov/snp/${item}" target="_blank">${item}${index + 1 < rs_id.length ? ', ' : ''}</a>`).join('')}
      </p>
      <p style="margin-bottom: 10px; font-size: 14px;"><strong>Ensembl:</strong> 
        ${rs_id.map((item, index) => `<a class="resource" style="font-size: 14px;" href="https://useast.ensembl.org/homo_sapiens/Variation/Summary?v=${item}" target="_blank">${item}${index + 1 < rs_id.length ? ', ' : ''}</a>`).join('')}
      </p>
      <p style="margin-bottom: 10px; font-size: 14px;"><strong>ClinVar:</strong> 
        ${rs_id.map((item, index) => `<a class="resource" style="font-size: 14px;" href="https://www.ncbi.nlm.nih.gov/clinvar/?term=${item}" target="_blank">${item}${index + 1 < rs_id.length ? ', ' : ''}</a>`).join('')}
      </p>
      <p style="margin-bottom: 10px; font-size: 14px;"><strong>OMIM:</strong> 
        ${rs_id.map((item, index) => `<a class="resource" style="font-size: 14px;" href="https://www.omim.org/search?index=entry&start=1&limit=10&sort=score+desc%2C+prefix_sort+desc&search=${item}" target="_blank">${item}${index + 1 < rs_id.length ? ', ' : ''}</a>`).join('')}
      </p>
      <p style="margin-bottom: 10px; font-size: 14px;"><strong>IEU OpenGWAS:</strong> 
        ${rs_id.map((item, index) => `<a class="resource" style="font-size: 14px;" href="https://gwas.mrcieu.ac.uk/phewas/${item}" target="_blank">${item}${index + 1 < rs_id.length ? ', ' : ''}</a>`).join('')}
      </p>
      <p style="margin-bottom: 10px; font-size: 14px;"><strong>Global Biobank Engine:</strong> 
        <a class="resource" style="font-size: 14px;" href="https://biobankengine.stanford.edu/RIVAS_HG19/variant/${id.replace(/\_/g, '-')}" target="_blank">Global Biobank Engine</a>
      </p>
    </div>
  `,
        confirmButtonText: 'Close',
        customClass: {
          title: 'swal-title',
          text: 'swal-text',
          confirmButton: 'swal-confirm-button',
        }
      });

    },
    informUpdate() {
      Swal.fire({
        title: '<p style="font-family:Ubuntu">Feature Update Notice<p>',
        html: '<p style="font-family:Ubuntu; font-size: 16px;">We would like to inform you that a new feature is scheduled for release in the next version of our software. You can request realease date <a class="resource-request" target="_blank" href="https://form.jotform.com/242403221223438">here</a>.</p>',
        icon: 'info',
        confirmButtonText: 'Understood',
        iconColor: '#A51C30',
        customClass: {
          title: 'swal-title',
          text: 'swal-text',
          confirmButton: 'swal-confirm-button',
        }
      });
    },
    copy() {
      navigator.clipboard.writeText(this.id);
      this.isClicked = true;
      setTimeout(() => {
        this.isClicked = false;
      }, 1000);
    },
    axiosHandler() {
      const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_ROOT_API,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "ages_hms_access_token",
          )}`,
        },
      });
      return axiosInstance;
    },
    setUpPage() {
      if (!this.hasLogined) {
        this.status = "FAIL";
        return
      }
      const headers = {
        "Content-Type": "text/plain",
      };
      this.id = this.$route.params.id;
      let password = localStorage.getItem("user-password");
      this.axiosHandler()
        .post(`/api/search-id-rsid`, {
          prefix: this.id,
        })
        .then((response) => {
          let results = response.data.id_rsid;
          let flag = response.data.flag;
          if (flag != "match") {
            this.status = "FAIL";
          } else {
            this.id = results[0][0];
            let rs_ids = results[0][1];
            if (rs_ids != null) {
              this.rs_id = rs_ids;
            }
            this.axiosHandler()
              .post(`/api/fetch_data`, {
                id: this.id,
                client_id: localStorage.getItem('client_id')
              })
              .then((response) => {
                this.$store.state.glmmData = response.data.glmm_json;
                this.metaInfo = response.data.meta_info;
                this.$store.state.firstPhenoId = response.data.first_pheno_id;
                this.$store.state.clientId = response.data.client_id;
                this.clientId = this.$store.state.clientId;
                this.$store.state.id = this.id;
                this.$store.state.gtSlope = response.data.gt_slope;
                this.$store.state.gtBeta = response.data.gt_slope_beta;
                this.$store.state.derivedAlleleFreq = response.data.daf_json;
                localStorage.setItem("client_id", response.data.client_id)
                this.status = "DONE";
              })
              .catch((response) => {
                console.log(response);
                this.status = "FAIL";
              });
          }
        })
        .catch((response) => {
          console.log(response);
          this.status = "FAIL";
        });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200");

.description {
  padding-bottom: 0;
  font-size: 1.15rem;
  color: white;
  cursor: pointer;
}

#mainContainer {
  display: flex;
  margin-top: 1rem;
  flex-wrap: wrap;
  height: auto;
  margin: 0 auto;
  margin-top: 100px;
  margin-bottom: 50px;
  justify-content: center;
  width: 990px;
  align-items: center;
  flex-direction: column;
  position: relative;
  border-radius: 3px;
  box-shadow: 0 0 2px #1E1E1E;
  border: 0.6px solid #1E1E1E;
  background-color: white;
}

.external-resource {
  text-decoration: none;
  padding: 0.3rem 1rem;
  font-size: 19px;
  font-weight: bold;
}

.resource {
  color: #A51C30;
  text-decoration: none;
  margin-left: 0.05rem;
  font-size: 17px;
  transition: 250ms;
}

.resource:hover {
  background-color: #f592a127;
  border-radius: 4px;
  transition: 250ms;
}

.resource-request {
  color: #A51C30;
  text-decoration: none;
  margin-left: 0.05rem;
  font-size: 16px;
  transition: 250ms;
}

.resource-request:hover {
  background-color: #f592a127;
  border-radius: 4px;
  transition: 250ms;
}


.resource-link:hover {
  background-color: #f592a127;
  border-radius: 4px;
  transition: 250ms;
}

.resource-link {
  margin-top: 0.1rem;
  margin-bottom: 0.4rem;
  margin-left: 4.3rem;
  font-size: 15px;
  transition: 250ms;
}

.waiting {
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.loadbar {
  margin-top: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.loadbar h4 {
  margin-bottom: 0.8rem;
  font-size: 28px;
}

.v-spinner {
  margin: 0 auto;
}

.red {
  color: #A51C30;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem !important;
}

.warning {
  width: 45px;
  margin-right: 10px;
}

.system-coord {
  font-size: 1rem;
  font-weight: normal;
  position: relative;
}

.plots-div {
  display: flex;
  justify-content: space-between;
}

.copy-btn {
  outline: none;
  border: none;
  border-radius: 4px;
  border-radius: 3px;
  color: white;
  font-size: 1.2rem;
  margin-left: 15px;
  margin-top: 2px;
  cursor: pointer;
  padding: 3px;
  transition: 150ms;
}

.copy-btn .copy-btn:hover {
  transition: 150ms;
}

.info-btn {
  outline: none;
  border: none;
  color: white;
  position: relative;
  right: -3px;
  top: 5px;
  font-size: 20px;
  cursor: pointer;
  transition: 150ms;
}

.copy-btn.color-blue {
  background-color: #A51C30;
  transition: 250ms;
}

#tabbtn {
  position: absolute;
  left: 20px;
  top: -40px;
  border-bottom: none;
  width: 102px;
  height: 40px;
  border: 0.6px solid #1E1E1E;
  white-space: nowrap;
  box-shadow: 0 0 1px #1E1E1E;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  background-color: white;
}

#tabbtn button {
  outline: none;
  border: none;
  width: 101px;
  padding: 5px;
  border-radius: 3px;
  height: 39px;
  color: black;
  background-color: transparent;
  font-size: 14px;
  cursor: pointer;
}

#tabbtn button#gentab {
  border-radius: 0;
  border-top-left-radius: 3px;
}

#tabbtn button#phentab {
  border-radius: 0;
  border-top-right-radius: 3px;
}

#tabbtn button.active {
  background-color: #1E1E1E !important;
  color: white !important;
}

#title-hr {
  width: 90%;
  margin: 0 auto;
  margin-top: 15px;
  background-color: #1E1E1E;
  color: #A51C30;
}

#whole-intro {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: rows;
  padding-top: 1rem;
  justify-content: flex-start;
  border: 0.6px solid #1E1E1E;
  box-shadow: 0 0 2px #1E1E1E;
  width: 990px;
  margin: 0 auto;
  margin-top: 120px;
  position: relative;
  top: 15px;
  border-radius: 3px;
  height: 440px;
}

#variant-id-title {
  display: inline;
  background-color: #1E1E1E;
  padding: 10px 12px;
  position: absolute;
  top: -45px;
  left: 22px;
  height: 45px;
  width: auto;
  border: 0.6px solid #042f4a;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.wait-title {
  font-size: 60px;
}

.alert-small-screen {
  font-size: 1.3rem;
  width: 90vw;
  margin: 0 auto;
  text-align: center;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

#reg-info {
  margin-left: 20px;
  display: flex;
  justify-content: center;
  background-color: #1E1E1E;
  position: absolute;
  width: 580px;
  font-family: Ubuntu !important;
  height: 439px;
  right: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  top: 0;
  z-index: 999;
}

#reference {
  margin-left: 10px;
}

.variant-info-table {
  width: 330px;
  height: auto;
  border-collapse: collapse;
  font-family: 'Ubuntu', sans-serif;
}

.variant-info-table table {
  width: 100%;
  position: relative;
  top: -15px;
  border-radius: 5px;
  table-layout: fixed;
  border-spacing: 0px;
}

.variant-info-table th,
.variant-info-table td {
  text-align: left;
  padding: 6.5px;
  padding-top: 10px;
  padding-bottom: 13px;
  border: none !important;

  background-color: white !important;
  font-size: 13px;
  white-space: nowrap;
  max-width: 320px;
}

.variant-info-table th {
  background-color: #f2f2f2;
  color: #333;
  font-weight: bold;
  border-bottom: 2px solid #ccc;
  text-transform: uppercase;
}

.variant-info-table td {
  color: #555;
  border-bottom: 1px solid #eee;
}

.rsid-badge {
  background-color: #A51C30;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: normal;
  max-width: 200px;
  text-overflow: ellipsis;
}

.pass-badge {
  background-color: #F3F3F1;
  color: black;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 13px;
  max-width: 300px;
  cursor: pointer;
  font-weight: normal;
  max-width: 100px;
  text-overflow: ellipsis;
}

.discrepancy-badge {
  background-color: #F3F3F1;
  color: black;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 13px;
  max-width: 100px;
  font-weight: normal;
}

.right-col {
  text-align: right !important;
  padding-right: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #BAC5C6;
  -webkit-transition: 250ms;
  transition: 250ms;
}

.slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 250ms;
  transition: 250ms;
}

input:checked+.slider {
  background-color: #BAC5C6;
}

input:focus+.slider {
  box-shadow: 0 0 1px #BAC5C6;
}

input:checked+.slider:before {
  -webkit-transform: translateX(10px);
  -ms-transform: translateX(10px);
  transform: translateX(10px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}


.switch-pos {
  position: absolute;
  left: 425px;
  top: 13px;
  z-index: 99999;
}

.swal-confirm-button {
  background-color: #A51C30 !important;
  color: white !important;
  border: none !important;
  outline: none !important;
  box-shadow: 0 0 5px #a51c316b !important;
  font-family: Ubuntu;
}

.apexcharts-zoom-icon {
  opacity: 0;
  cursor: default !important;
}

.legend-box {
  position: absolute;
  right: 160px;
  justify-content: space-between;
  top: 15px;
  display: flex;
}

.legend {
  color: white;
  font-size: 13px;
  z-index: 9999;
  margin-right: 10px;

}

.legend-item-steppe {
  cursor: pointer;
  z-index: 9999;
  content: "..";
  margin-right: 5px;
  width: 30px;
  height: 30px;
  padding: 0 4px;
  border-radius: 10px;
  background-color: #fa3c6c;
  color: #fa3c6c;
}

.legend-item-whg {
  cursor: pointer;
  z-index: 9999;
  content: "..";
  margin-right: 5px;
  width: 30px;
  height: 30px;
  padding: 0 4px;
  border-radius: 10px;
  background-color: #3fb543;
  color: #3fb543;
}

.legend-item-eef {
  cursor: pointer;
  z-index: 9999;
  margin-right: 5px;
  content: "..";
  width: 30px;
  height: 30px;
  padding: 0 4px;
  border-radius: 10px;
  background-color: #e8bd10;
  color: #e8bd10;
}

.legend-item-observed {
  cursor: pointer;
  z-index: 9999;
  margin-right: 3px;
  content: "..";
  width: 30px;
  height: 5px;
  padding: 0 1px;
  border-radius: 4px;
  background-color: #4E84C4;
  color: #4E84C4;
}

.legend-item-prediction {
  cursor: pointer;
  z-index: 9999;
  content: "..";
  width: 30px;
  height: 5px;
  margin-right: 3px;
  padding: 0 1px;
  border-radius: 4px;
  background-color: #D16103;
  color: #D16103;
}

/* Common Hover Effect */
.legend-item-steppe:hover,
.legend-item-whg:hover,
.legend-item-eef:hover,
.legend-item-observed:hover,
.legend-item-prediction:hover {
  transform: scale(1.1);
  /* Slight zoom-in effect */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  /* Add a subtle shadow */
}

.legend-item-steppe:focus,
.legend-item-whg:focus,
.legend-item-eef:focus,
.legend-item-observed:focus,
.legend-item-prediction:focus {
  outline: 3px solid #f39c12;
  /* Add focus outline */
  outline-offset: 2px;
}

.download-reg {
  position: absolute;
  left: 502px;
  top: 11px;
  font-weight: normal;
  font-size: 21px;
  color: white;
  z-index: 999999;
  cursor: pointer;
}

.expand-reg {
  position: absolute;
  left: 530px;
  top: 11px;
  font-weight: normal;
  font-size: 21px;
  color: white;
  z-index: 999999;
  cursor: pointer;
}

.reset-reg {
  position: absolute;
  left: 553px;
  top: 11px;
  font-weight: normal;
  font-size: 21px;
  color: white;
  z-index: 999999;
  cursor: pointer;
}

.download-reg-tsv {
  position: absolute;
  left: 472px;
  font-weight: normal;
  font-size: 21px;
  top: 11px;
  color: white;
  z-index: 999999;
  cursor: pointer;

}

.toast {
  position: fixed;
  top: 13%;
  /* Position it 50% from the top */
  left: 50%;
  /* Position it 50% from the left */
  transform: translate(-50%, -50%);
  /* Center it by shifting it back by 50% of its own width and height */
  padding: 10px 10px;
  background-color: #A51C30;
  color: white;
  border-radius: 4px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  font-family: Ubuntu;
  font-weight: normal;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.12s ease;
}
</style>
